import header from "./header";
import home from "./home";
import scripDetail from "./common/ScripDetailReducer";
import footer from "./footer";
import holdingReport from "./Reports/HoldingReport";
import positionReport from "./Reports/PositionReport";
import dashboardSummary from "./Reports/dashboardSummary";
import understandSection from "./Reports/UnderstandingSection";
import pnlReport from "./Reports/PNLReport";
import pnltranasactionReport from "./Reports/PNLTransactionReport";
import taxReport from "./Reports/TaxReport";
import accountDetailsReducer from "./userdetail";
import jwtTokenNestTraderReducer from "./JwtTokenNestReducer";
import markets from "../feature/Markets/markets";
import extPlatDataRetrieveReducer from "./ExtPlatDataRetrieveReducer";
import staticFooter from "./StaticFooter";
import watchList from "@redux/feature/WatchList/Reducers/watchList";
import LoginFlow from "@redux/feature/LoginFlow/Reducers/LoginFlow";
// import MarginReports from "@redux/reducers/Reports/MarginReports";
import Contract from "@redux/reducers/Reports/ContractStatement";
import TOCJourney from "@redux/feature/TOCJourney/Reducers/TOCJourney";
import BasicProfile from "@redux/feature/BasicProfile/reducers/BasicProfile";
import EDIS from "@redux/feature/EDIS/Reducers/EDIS";
import TransactionHistory from "@redux/reducers/Reports/TransactionHistory";
import SubscriptionReport from "@redux/reducers/Reports/SubscriptionReport/index";
import fundTransfer from "@redux/feature/FundTransfer/Reducers/FundTransfer";
import liveNews from "@redux/feature/LiveNews/Reducers/LiveNews";
import orderBook from "@redux/feature/OrderBook/orderBook";
import epledge from "@redux/feature/Epledge/Reducers/Epledge";
import tools from "@redux/feature/Tools/tools";
import eventCalendarReducer from "@redux/feature/EventCalendar/Reducers/eventCalendar";
import SGBReducer from "../feature/Offers/SGB/Reducers/sgbReducer";
import ticketPortal from "@redux/feature/TicketPortal/Reducers/TicketPortal";
import LedgerReport from "@redux/reducers/Reports/LedgerReport";
import DpInterest from "./Reports/DpInterest";
import DpBills from "./Reports/DpBills";
import alerts from "@redux/feature/Alerts/Alerts";
import postLogin from "@redux/feature/PostLogin/PostLoginReducer";
import offerings from "@redux/feature/Offers/OffersReducer";
import quotes from "@redux/feature/Quotes/Quote";
import Profile from "@redux/feature/Profile";
import Lead from "@redux/feature/Lead";
import SalesHome from "@redux/feature/SalesHome";
import NRDashboard from "@redux/feature/NRDashboard";
import Login from "@redux/feature/Login";
import Clients from "@redux/feature/Clients";
import Partners from "@redux/feature/Partners";
import PartnerNRDashboard from "@redux/feature/PartnerNRDashboard";
import Common from "@redux/feature/Common";
import { combineReducers } from "redux";
import Bookmarks from "@redux/feature/Bookmarks/Reducers/Bookmarks";
import AccountOverview from "@redux/reducers/Reports/AccountOverview/AccountOverview";
import Holding from "./Reports/CoreReports/HoldingReducer";
import PnlReport from "./Reports/CoreReports/ProfitAndlossReducer";
import Family from "./Reports/FamilyTagging";
import taxReportReducer from "./Reports/CoreReports/taxReportReducer";
import position from "./Reports/CoreReports/PositionRevampReducer";
import DownloadNSendEmailReport from "./Reports/CoreReports/DownloadNSendEmailReport";
import OrderbookMutualFundsTransactions from "@redux/feature/ActivityBook/OrderBook/MutualFund/Reducers/MutualFunds";
export default combineReducers({
    header: header,
    home: home,
    footer: footer,
    scripDetail: scripDetail,
    holdingReport: holdingReport,
    positionReport: positionReport,
    understandSection: understandSection,
    pnlReport: pnlReport,
    pnltranasactionReport: pnltranasactionReport,
    taxReport: taxReport,
    accountDetailsReducer: accountDetailsReducer,
    jwtTokenNestTraderReducer: jwtTokenNestTraderReducer,
    markets: markets,
    extPlatDataRetrieveReducer: extPlatDataRetrieveReducer,
    dashboardSummary: dashboardSummary,
    staticFooter: staticFooter,
    watchList: watchList,
    LoginFlow: LoginFlow,
    // MarginReports,
    Contract: Contract,
    TOCJourney: TOCJourney,
    BasicProfile: BasicProfile,
    EDIS: EDIS,
    orderBook: orderBook,
    epledge: epledge,
    tools: tools,
    ticketPortal: ticketPortal,
    TransactionHistory: TransactionHistory,
    SubscriptionReport: SubscriptionReport,
    LedgerReport: LedgerReport,
    DpInterest: DpInterest,
    DpBills: DpBills,
    eventCalendarReducer: eventCalendarReducer,
    offerings: offerings,
    fundTransfer: fundTransfer,
    SGB: SGBReducer,
    liveNews: liveNews,
    alerts: alerts,
    postLogin: postLogin,
    quotes: quotes,
    AccountOverview: AccountOverview,
    holdingRevamp: Holding,
    pnlRevamp: PnlReport,
    downloadRevamp: DownloadNSendEmailReport,
    /*sales*/
    Login: Login,
    Profile: Profile,
    SalesHome: SalesHome,
    NRDashboard: NRDashboard,
    Lead: Lead,
    Clients: Clients,
    Partners: Partners,
    PartnerNRDashboard: PartnerNRDashboard,
    Common: Common,
    Bookmarks: Bookmarks,
    OrderbookMutualFundsTransactions: OrderbookMutualFundsTransactions,
    taxRevamp: taxReportReducer,
    FamilyTagging: Family,
    positionRevamp: position,
    /*sales*/
});
